import { useProductCardRefContext } from 'product-card/hooks/useProductCardRefContext'
import { useEffect, useRef, useState } from 'react'

export const useProductCardFocused = () => {
	const { productCardRef } = useProductCardRefContext()
	const isKeyboardNavigationActive = useRef(false)
	const [isFocused, setIsFocused] = useState(false)

	useEffect(() => {
		const node = productCardRef.current

		const handleFocusIn = () => {
			if (isKeyboardNavigationActive.current) {
				setIsFocused(true)
			}
		}

		const handleFocusOut = (e: FocusEvent) => {
			if (!node?.contains(e.relatedTarget as Node)) {
				setIsFocused(false)
			}
		}

		const handleKeyDown = () => {
			isKeyboardNavigationActive.current = true
		}
		const handleMouseDown = () => {
			isKeyboardNavigationActive.current = false
		}

		node?.addEventListener('keydown', handleKeyDown)
		node?.addEventListener('mousedown', handleMouseDown)
		node?.addEventListener('focusin', handleFocusIn)
		node?.addEventListener('focusout', handleFocusOut)

		return () => {
			node?.removeEventListener('focusin', handleFocusIn)
			node?.removeEventListener('focusout', handleFocusOut)
			node?.removeEventListener('keydown', handleKeyDown)
			node?.removeEventListener('mousedown', handleMouseDown)
		}
	}, [productCardRef])

	return isFocused
}
